import React from 'react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-slate-dark text-pure-white text-xs sm:text-sm font-medium py-2 px-4 text-center" data-id="element-139">
      ENTREGA INMEDIATA A TU EMAIL 📧 • 80% OFF SOLO POR HOY
    </div>;
}